// Readability Analyzer Tool — Flesch reading ease and grade level.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const readabilityTool: Tool = {
  id: "readability",
  name: () => m.ra_tool_name(),
  description: () => m.ra_tool_description(),
  icon: "📖",
  basePath: "/readability-checker",
  status: "stable",
  tags: ["readability", "flesch", "writing", "text"],
  pages: [
    {
      name: () => m.ra_nav_main(),
      path: "/readability-checker",
      description: () => m.ra_nav_main_desc(),
      icon: "📖",
    },
  ],
};
